var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgRadioboxMarkedIconcom = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 22 22",
  width: "1em",
  height: "1em",
  fill: "currentColor"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  transform: "translate(1 1)",
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("circle", {
  stroke: "#333",
  cx: 10,
  cy: 10,
  r: 10
}), /*#__PURE__*/React.createElement("circle", {
  fill: "#E87524",
  cx: 10,
  cy: 10,
  r: 6
}))));
export default SvgRadioboxMarkedIconcom;